/* Bloc paiement Rog (11/10/2026 ; PayPal et Paiement en 4X PayPal le 28/10/2026). Remplace le bloc Klarna de la fiche (même place, carte « Votre configuration »),
   ajoute une ligne « paiement » au panier et remplit la page /pages/paiement.
   21/10/2026 (Léo) : sur la fiche, le bloc fait payer. Au clic, la configuration part au panier par le bouton
   « Ajouter au panier » de la fiche (mêmes options Globo, véhicule, VIN), puis le client arrive directement au
   paiement Shopify (paiement express en haut). La fenêtre d'information reste au panier et sur /pages/paiement.
   Textes : snippets/rog-paiement.liquid (21 langues). Le virement n'apparaît que si le métachamp de boutique
   rog.virement_actif vaut true, et seulement pour les pays de la zone SEPA (virement en euros). */
(function () {
  var data = document.getElementById('rog-paiement-data');
  if (!data) return;
  var C; try { C = JSON.parse(data.textContent); } catch (e) { return; }
  var T = C.t || {}; if (!T.fiche_titre) return;

  /* Klarna retiré partout le 29/10/2026 (Léo : « supprime klarna, de partout ») : 16 tentatives, aucune réussite. */
  /* Paiement en 4X PayPal (28/10/2026, pages PayPal France) : particuliers résidant en France, achats de 20 à 3 000 €,
     sous réserve d'acceptation par PayPal ; le client le choisit dans la fenêtre PayPal. Jamais affiché hors de ces cas. */
  var PAYPAL_4X_MIN = 20, PAYPAL_4X_MAX = 3000;
  /* Interrupteur unique : false retire le 4 fois PayPal de la fiche, du panier, de la fenêtre et de la page. */
  var PAYPAL_4X_ACTIF = true;
  /* Ordonnance 2025-880 (crédit à la consommation), en vigueur le 20/11/2026 : toute publicité pour un paiement en
     plusieurs fois, même sans frais, porte « Attention ! Un crédit coûte de l'argent et doit être remboursé. ».
     La mention apparaît d'elle-même à partir de cette date, partout où le 4 fois PayPal est annoncé. */
  var CREDIT_MENTION = Date.now() >= Date.parse('2026-11-19T23:00:00Z');
  function mentionHTML(cls) { return CREDIT_MENTION && T.credit_mention ? '<p class="' + cls + '">' + esc(T.credit_mention) + '</p>' : ''; }
  var SEPA = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE IS LI NO CH GB MC SM AD VA'.split(' ');
  var LOCAUX = { BE: 'Bancontact', NL: 'iDEAL | Wero', PL: 'BLIK', IT: 'Satispay', CH: 'TWINT', AT: 'EPS', PT: 'MB WAY', DK: 'MobilePay', FI: 'MobilePay' };
  var pays = C.pays || 'FR';
  var virement = !!C.virement && SEPA.indexOf(pays) >= 0;
  var local = LOCAUX[pays] || '';
  var france = pays === 'FR' && C.devise === 'EUR';
  function eligible4x(total) { return PAYPAL_4X_ACTIF && france && !!T.fiche_4x_titre && total >= PAYPAL_4X_MIN && total <= PAYPAL_4X_MAX; }
  /* Logos officiels rendus par Shopify (snippet, <template id="rog-paiement-logos">), dans l'ordre demandé. */
  function logosHTML(noms) {
    var tpl = document.getElementById('rog-paiement-logos');
    if (!tpl) return '';
    var box = document.createElement('div'); box.appendChild(tpl.content.cloneNode(true));
    return noms.map(function (n) {
      var t = box.querySelector('[aria-labelledby="pi-' + n + '"]');
      return t ? t.outerHTML : '';
    }).join('');
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function liens(s) {
    return esc(s).replace(/contact@rogmotorsport\.com/g, '<a href="mailto:contact@rogmotorsport.com">contact@rogmotorsport.com</a>')
      .replace(/07 56 95 95 39/g, '<a href="tel:+33756959539">07 56 95 95 39</a>');
  }
  var cadenas = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="2.6" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M8.2 10.5V8a3.8 3.8 0 0 1 7.6 0v2.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var chev = '<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M3.5 1.5 7 5l-3.5 3.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var croix = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 2l8 8M10 2 2 10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  /* Sans virement activé, on garde seulement la première phrase du texte carte (la seconde renvoie au virement). */
  function carteTexte() { return virement ? T.carte_texte : String(T.carte_texte).split(/(?<=[.!?。])\s/)[0]; }
  /* avec4x : la ligne « 4 fois sans frais avec PayPal » (France, ou page en français : la page dit ses conditions). */
  function moyens(avec4x) {
    var l = [{ t: T.carte_titre, d: carteTexte(), g: ['apple_pay', 'visa', 'master', 'american_express'] }];
    if (T.paypal_titre) {
      if (avec4x) l.push({ t: T.paypal4_titre, b: T.paypal4_badge, d: T.paypal4_texte, n: T.paypal4_conditions, g: ['paypal'], p: true });
      l.push({ t: T.paypal_titre, d: T.paypal_texte, g: avec4x ? [] : ['paypal'] });
    }
    if (virement) l.push({ t: T.virement_titre, b: T.virement_badge, d: T.virement_texte, r: T.virement_rassure, v: true });
    if (local) l.push({ t: T.local_titre, d: local });
    return l;
  }
  function listeHTML(cls, avec4x) {
    return '<ul class="' + cls + '">' + moyens(avec4x).map(function (m) {
      var g = m.g && m.g.length ? '<span class="rp-li-logos">' + logosHTML(m.g) + '</span>' : '';
      return '<li' + (m.v || m.p ? ' class="rp-v"' : '') + '><div class="rp-li-t"><b>' + esc(m.t) + '</b>' + (m.b ? '<span class="rp-badge">' + esc(m.b) + '</span>' : '') + g + '</div><p>' + esc(m.d) + '</p>' +
        (m.n ? '<p class="rp-cond">' + esc(m.n) + '</p>' + mentionHTML('rp-cond rp-mention') : '') + (m.r ? '<p class="rp-rassure">' + esc(m.r) + '</p>' : '') + '</li>';
    }).join('') + '</ul>';
  }

  /* ---------- Fenêtre « Payer votre ligne. » ---------- */
  var voile = null, dernier = null;
  function fermer() {
    if (!voile) return;
    voile.removeAttribute('data-ouvert');
    var v = voile; voile = null;
    document.removeEventListener('keydown', clavier);
    setTimeout(function () { v.remove(); }, 200);
    if (dernier && dernier.focus) dernier.focus();
  }
  function clavier(e) { if (e.key === 'Escape') fermer(); }
  function ouvrir(depuis) {
    if (voile) return;
    dernier = depuis || document.activeElement;
    voile = document.createElement('div');
    voile.className = 'rp-voile';
    voile.innerHTML = '<div class="rp-fen" role="dialog" aria-modal="true" aria-labelledby="rp-titre">' +
      '<div class="rp-haut"><h2 id="rp-titre">' + esc(T.fenetre_titre) + '</h2><button type="button" class="rp-x" aria-label="' + esc(T.fermer) + '">' + croix + '</button></div>' +
      '<p class="rp-chapo">' + esc(T.fenetre_intro) + '</p>' + listeHTML('rp-liste', PAYPAL_4X_ACTIF && france) +
      '<p class="rp-note">' + esc(T.facture_texte) + '</p>' +
      '<p class="rp-note">' + esc(T.securite_texte) + '</p>' +
      '<p class="rp-note">' + liens(T.contact_texte) + '</p>' +
      (C.page ? '<a class="rp-lien" href="' + esc(C.page) + '">' + esc(T.lien_page) + ' <span aria-hidden="true">›</span></a>' : '') +
      '</div>';
    document.body.appendChild(voile);
    voile.addEventListener('click', function (e) { if (e.target === voile) fermer(); });
    voile.querySelector('.rp-x').addEventListener('click', fermer);
    document.addEventListener('keydown', clavier);
    requestAnimationFrame(function () { voile.setAttribute('data-ouvert', ''); voile.querySelector('.rp-x').focus(); });
  }
  window.rogPaiementOuvrir = ouvrir;

  /* ---------- Fiche : ligne sous « Livraison offerte » ---------- */
  function montant(txt) {
    var s = String(txt || '').replace(/[^\d.,]/g, '');
    if (!s) return 0;
    var m = s.match(/[.,](\d{2})$/);
    var dec = m ? m[1] : '';
    var ent = (m ? s.slice(0, -3) : s).replace(/[.,]/g, '');
    return parseFloat(ent + (dec ? '.' + dec : '')) || 0;
  }
  /* Fiche (28/10/2026, étape 3, Léo : « il clique sur un des deux, et bam ») : une carte de lignes cliquables sous
     « Ajouter au panier ». Chaque ligne ajoute la configuration au panier par le vrai bouton de la fiche, puis :
     · PayPal (4 fois en France de 20 à 3 000 €, sinon en une fois) : le panier s'ouvre sur le vrai bouton PayPal ;
     · carte / Apple Pay / virement : paiement Shopify direct (21/10/2026). */
  function fiche() {
    var carte = document.querySelector('.rogx-config__droite');
    if (!carte || carte.querySelector('.rp-choix')) return;
    var ancre = carte.querySelector('p.rogx-recap-mention') || carte.querySelector('.product-form__buttons');
    if (!ancre) return;
    var fmt; try { fmt = new Intl.NumberFormat((C.locale || 'fr') + '-' + pays, { style: 'currency', currency: 'EUR' }); } catch (e) { fmt = null; }
    function lirePrix() { return carte.querySelector('.price-item--sale') || carte.querySelector('.price__regular .price-item--regular') || carte.querySelector('.price-item--regular'); }
    function ligneHTML(mode, logo) {
      return '<button type="button" class="rp-l" data-rp-mode="' + mode + '"><span class="rp-l__logo">' + logo + '</span>' +
        '<span class="rp-l__txt"><b></b><span></span></span><span class="rp-chev">' + chev + '</span></button>';
    }
    var boite = document.createElement('div');
    boite.className = 'rp-choix';
    boite.innerHTML = ligneHTML('paypal', logosHTML(['paypal'])) +
      ligneHTML('carte', '<span class="rp-l__cadenas">' + cadenas + '</span>');
    var bloc = ancre;
    while (bloc && bloc.parentElement !== carte) bloc = bloc.parentElement;
    if (bloc) {
      var ligne = document.createElement('div');
      ligne.className = 'rp-bloc';
      var premier = carte.firstElementChild;
      var marge = premier ? getComputedStyle(premier).paddingLeft : '24px';
      ligne.style.paddingLeft = marge; ligne.style.paddingRight = marge;
      ligne.appendChild(boite);
      bloc.insertAdjacentElement('afterend', ligne);
    } else {
      ancre.insertAdjacentElement('afterend', boite);
    }
    var mention = null;
    if (CREDIT_MENTION && T.credit_mention) {
      mention = document.createElement('p'); mention.className = 'rp-mention rp-mention--fiche'; mention.textContent = T.credit_mention;
      boite.insertAdjacentElement('afterend', mention);
    }
    var lPP = boite.querySelector('[data-rp-mode="paypal"]'), lCB = boite.querySelector('[data-rp-mode="carte"]');
    function ecrire(l, titre, sous) { l.querySelector('b').textContent = titre; l.querySelector('.rp-l__txt span').textContent = sous || ''; }
    var dernierTotal = -1;
    function maj() {
      var prix = lirePrix();
      var total = prix ? montant(prix.textContent) : 0;
      if (total === dernierTotal) return;
      dernierTotal = total;
      if (eligible4x(total) && fmt) ecrire(lPP, T.fiche_4x_titre.replace('{x}', fmt.format(Math.floor(total * 100 / 4) / 100)), T.fiche_4x_detail);
      else ecrire(lPP, T.fiche_pp_titre, T.fiche_pp_sous);
      ecrire(lCB, virement ? T.fiche_carte_avec_virement : T.fiche_carte_sans_virement, T.fiche_titre);
      if (mention) mention.hidden = !eligible4x(total);
    }
    maj();
    var attente = null;
    new MutationObserver(function (liste) {
      for (var i = 0; i < liste.length; i++) {
        var cible = liste[i].target;
        if (cible.nodeType !== 1) cible = cible.parentNode;
        if (cible && cible.closest && cible.closest('.rp-bloc')) continue;
        clearTimeout(attente); attente = setTimeout(maj, 60); return;
      }
    }).observe(carte, { childList: true, characterData: true, subtree: true });
    boite.addEventListener('click', function (e) {
      var l = e.target.closest('.rp-l');
      if (l) payer(l, carte, l.getAttribute('data-rp-mode'));
    });
  }

  /* ---------- Fiche : le bloc mène au paiement ---------- */
  var racineUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function lirePanier() {
    return fetch(racineUrl + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  /* Champ Globo obligatoire resté vide (véhicule) : on n'ira pas au paiement. */
  function champVide(form) {
    var l = form.querySelectorAll('.gpo-element input[type="text"][presence], .gpo-element input[type="text"][required]');
    for (var i = 0; i < l.length; i++) if (l[i].offsetParent && !String(l[i].value || '').trim()) return l[i];
    return null;
  }
  function payer(btn, carte, mode) {
    if (btn.classList.contains('rp-attente') || (btn.parentNode && btn.parentNode.querySelector('.rp-attente'))) return;
    var form = carte.querySelector('form[action*="/cart/add"]') || document.querySelector('.section-product form[action*="/cart/add"]');
    var ajout = form && (form.querySelector('button[type="submit"][name="add"]') || form.querySelector('[type="submit"]'));
    if (!ajout) { ouvrir(btn); return; }
    var vide = champVide(form);
    if (vide) {
      ajout.click(); /* Globo affiche son message sous le champ (remplacé plus bas par une phrase claire) */
      try { vide.scrollIntoView({ block: 'center', behavior: 'smooth' }); vide.focus({ preventScroll: true }); } catch (e) {}
      return;
    }
    btn.classList.add('rp-attente');
    lirePanier().then(function (avant) {
      ajout.click();
      var debut = Date.now(), dernier = '', stable = 0;
      (function suivre() {
        lirePanier().then(function (p) {
          var sig = p ? p.item_count + ':' + p.total_price : '';
          var change = p && (!avant || p.item_count !== avant.item_count || p.total_price !== avant.total_price);
          if (change && (avant || Date.now() - debut > 2500)) {
            stable = sig === dernier ? stable + 1 : 0;
            dernier = sig;
            /* deux relectures identiques : la ligne et ses suppléments Globo sont arrivés */
            if (stable >= 2) {
              /* Bloc « 4 fois PayPal » : le panier s'ouvre sur le vrai bouton PayPal et la consigne du 4X
                 (la page de paiement Shopify ne peut pas l'écrire). Sinon : paiement direct, comme le 21/10. */
              if (mode === 'paypal' && window.rogxPanierOuvrir) { btn.classList.remove('rp-attente'); window.rogxPanierOuvrir(); return; }
              window.location.href = racineUrl + 'checkout'; return;
            }
          }
          if (Date.now() - debut > 12000) { btn.classList.remove('rp-attente'); return; }
          setTimeout(suivre, 350);
        });
      })();
    });
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) document.querySelectorAll('.rp-attente').forEach(function (b) { b.classList.remove('rp-attente'); });
  });

  /* ---------- Panier : une ligne compacte, appelée par sections/rogx-panier.liquid ---------- */
  /* total : total du panier en centimes (sections/rogx-panier.liquid), pour n'annoncer le 4 fois PayPal que s'il existe. */
  window.rogPaiementPanier = function (total) {
    var noms = [T.panier_carte];
    if (local) noms.push(local);
    var quatre = eligible4x((total || 0) / 100);
    var html = '<div class="rp-panier"><button type="button" class="rp-panier__b" data-rp-ouvrir>' +
      '<span class="rp-ico">' + cadenas + '</span><span class="rp-panier__txt"><b>' + esc(T.panier_titre) + '</b><span>' +
      (quatre ? '<em>' + esc(T.panier_paypal4) + '</em> · ' : '') + esc(noms.join(', ')) +
      (T.paypal_titre && !quatre ? ' · ' + esc(T.paypal_titre) : '') +
      (virement ? ' · ' + esc(T.panier_virement) + ' <em>' + esc(T.panier_virement_detail) + '</em>' : '') +
      '</span></span><span class="rp-chev">' + chev + '</span></button></div>';
    return html;
  };
  /* Panier (28/10/2026, étape 2) : phrase sous les boutons PayPal / Apple Pay de Shopify quand le 4 fois existe ;
     total en centimes. Retourne '' sinon. */
  window.rogPaiementIndice = function (total) {
    var t = (total || 0) / 100;
    if (!eligible4x(t) || !T.panier_4x_indice) return '';
    var fmt; try { fmt = new Intl.NumberFormat((C.locale || 'fr') + '-' + pays, { style: 'currency', currency: 'EUR' }); } catch (e) { return ''; }
    return '<p class="rp-indice">' + esc(T.panier_4x_indice.replace('{x}', fmt.format(Math.floor(t * 100 / 4) / 100))) +
      (CREDIT_MENTION && T.credit_mention ? '<span class="rp-mention">' + esc(T.credit_mention) + '</span>' : '') + '</p>';
  };
  window.rogPaiementTexte = function (cle) { return T[cle] || ''; };
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-rp-ouvrir]');
    if (b) { e.preventDefault(); ouvrir(b); }
  });

  /* ---------- Page /pages/paiement ---------- */
  function page() {
    var p = document.getElementById('rog-paiement-page');
    if (!p || p.getAttribute('data-rp')) return;
    p.setAttribute('data-rp', '1');
    var avec4x = PAYPAL_4X_ACTIF && !!T.page_4x_titre && (france || C.locale === 'fr');
    var h = '<div class="rp-page"><h1>' + esc(T.page_titre) + '</h1><p class="rp-page__chapo">' + esc(T.page_intro) + '</p>' +
      '<h2>' + esc(T.page_moyens_titre) + '</h2>' + listeHTML('rp-liste rp-liste--page', avec4x);
    if (avec4x) {
      var f4; try { f4 = new Intl.NumberFormat((C.locale || 'fr') + '-FR', { style: 'currency', currency: 'EUR' }); } catch (e) { f4 = null; }
      var ex = f4 ? T.page_4x_exemple.replace('{t}', f4.format(2190).replace(/[.,]00(?=\D*$)/, '')).replace('{x}', f4.format(547.5)) : '';
      h += '<h2 id="paiement-4-fois">' + esc(T.page_4x_titre) + '</h2><p>' + esc(T.page_4x_intro) + '</p>' +
        '<div class="rp-4x"><span class="rp-4x__logo">' + logosHTML(['paypal']) + '</span><p class="rp-4x__ex">' + esc(ex) + '</p></div>' +
        '<ol class="rp-etapes">' + [T.page_4x_etape1, T.page_4x_etape2, T.page_4x_etape3, T.page_4x_etape4].map(function (x, i) { return '<li><i>' + (i + 1) + '</i><p>' + esc(x) + '</p></li>'; }).join('') + '</ol>' +
        '<p class="rp-page__cond">' + esc(T.page_4x_conditions) + '</p>' + mentionHTML('rp-page__cond rp-mention');
    }
    if (virement) {
      h += '<h2>' + esc(T.page_virement_titre) + '</h2><ol class="rp-etapes">' +
        [T.page_etape1, T.page_etape2, T.page_etape3, T.page_etape4].map(function (x, i) { return '<li><i>' + (i + 1) + '</i><p>' + esc(x) + '</p></li>'; }).join('') + '</ol>' +
        (T.virement_rassure ? '<p class="rp-page__rassure">' + esc(T.virement_rassure) + '</p>' : '');
    }
    h += '<h2>' + esc(T.page_securite_titre) + '</h2><ul class="rp-points">' +
      (virement ? '<li>' + esc(T.page_securite1) + '</li><li>' + esc(T.page_securite2) + '</li>' : '') + '<li>' + esc(T.page_securite3) + '</li></ul>';
    h += '<h2>' + esc(T.page_plafond_titre) + '</h2><p>' + esc(virement ? T.page_plafond_texte : carteTexte()) + '</p>';
    if (T.page_faq_titre) {
      var faq = [[T.page_q1, T.page_r1], [T.page_q2, T.page_r2], [T.page_q3, T.page_r3]];
      h += '<h2>' + esc(T.page_faq_titre) + '</h2><div class="rp-faq">' + faq.map(function (q) {
        return '<details><summary>' + esc(q[0]) + '</summary><p>' + esc(q[1]) + '</p></details>';
      }).join('') + '</div>';
      try {
        var ld = document.createElement('script'); ld.type = 'application/ld+json';
        ld.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: faq.map(function (q) {
          return { '@type': 'Question', name: q[0], acceptedAnswer: { '@type': 'Answer', text: q[1] } };
        }) });
        document.head.appendChild(ld);
      } catch (e) {}
    }
    h += '<h2>' + esc(T.page_contact_titre) + '</h2><p>' + liens(T.page_contact_texte) + '</p>' +
      '<div class="rp-page__boutons">' +
      (C.locale === 'fr' ? '<a class="rp-btn" href="tel:+33756959539">' + esc(T.bouton_appeler || '07 56 95 95 39') + ' · 07 56 95 95 39</a>' : '') +
      '<a class="rp-btn rp-btn--contour" href="mailto:contact@rogmotorsport.com">' + esc(T.bouton_ecrire || 'contact@rogmotorsport.com') + '</a></div></div>';
    p.innerHTML = h;
  }

  /* ---------- Fiche : une option déjà choisie ne se décoche plus d'un clic ----------
     Globo décoche une vignette quand on la touche une seconde fois ; le client qui « confirme » ROG en touchant
     la vignette déjà choisie se retrouvait sans système à clapets et l'ajout au panier était refusé (constaté le 11/10/2026).
     On juge sur le clic de la carte ou du libellé, quand le bouton radio n'a pas encore bougé. Le clic que le navigateur
     (ou rog-configurateur.js) envoie au bouton radio lui-même n'est jamais bloqué : le navigateur l'a déjà coché avant
     d'appeler ce code, et le bloquer annulait toute nouvelle sélection (aucune option Globo ne se choisissait, 11 au 14/10/2026). */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || t.tagName === 'INPUT') return;
    var cible = t.closest('.gpo-element .gpo-ov-item, .gpo-element label');
    if (!cible) return;
    var inp = cible.querySelector('input[type="radio"]') || (cible.htmlFor && document.getElementById(cible.htmlFor));
    if (inp && inp.type === 'radio' && inp.checked) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  /* ---------- Fiche : message clair sous le champ véhicule obligatoire ----------
     Globo affiche « Vous devez sélectionner une option » sous un champ texte vide : on le remplace par une phrase juste. */
  var VEHICULE = { fr: 'Indiquez votre véhicule.', en: 'Please enter your vehicle.', de: 'Bitte geben Sie Ihr Fahrzeug an.', nl: 'Vul uw voertuig in.',
    es: 'Indique su vehículo.', it: 'Indichi il Suo veicolo.', 'pt-PT': 'Indique o seu veículo.', pl: 'Prosimy podać pojazd.', cs: 'Uveďte své vozidlo.',
    sk: 'Uveďte svoje vozidlo.', sl: 'Navedite svoje vozilo.', hr: 'Navedite svoje vozilo.', hu: 'Adja meg a járművét.', ro: 'Indicați vehiculul dumneavoastră.',
    bg: 'Посочете автомобила си.', el: 'Δηλώστε το όχημά σας.', lt: 'Nurodykite savo automobilį.', fi: 'Kerro ajoneuvosi.', sv: 'Ange din bil.',
    da: 'Angiv din bil.', nb: 'Oppgi bilen din.' };
  function messagesVehicule() {
    var msg = VEHICULE[C.locale] || VEHICULE.en;
    document.querySelectorAll('.gpo-element').forEach(function (el) {
      var champ = el.querySelector('input[type="text"]:not([name="VIN"])');
      if (!champ) return;
      el.querySelectorAll('[class*="error"]').forEach(function (e) {
        if (e.children.length === 0 && e.textContent.trim() && e.textContent.trim() !== msg) e.textContent = msg;
      });
    });
  }
  if (window.MutationObserver) {
    var attenteV = null;
    new MutationObserver(function () { clearTimeout(attenteV); attenteV = setTimeout(messagesVehicule, 30); })
      .observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  function init() { fiche(); page(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setTimeout(init, 1500);
})();
